import script from "./Radar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Radar.vue?vue&type=script&setup=true&lang=ts"

import "./Radar.vue?vue&type=style&index=0&id=33d803d1&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d803d1"]])

export default __exports__